/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from 'react'
import { Column } from 'react-table';
import CustomTable from '../../../../widgets/table'
import Pagination from '../../../../widgets/pagination'
import { useTranslation } from 'react-i18next';

//History table section under Exception Handling area
interface HistoryProps {
  plateDetailsHistory: string[];
  prodScheduleList: string[];
  productList: string[];
  columnsHistory: Column[];
  totalElementsHistory: number;
  pageHistory: number;
  totalPagesHistory: number;
  sortRemovelistHistory:string[];
  handleFilter: (key: string, value: any) => void;
  handleHistoryPageChange: (newPage: any) => void;
  handleSort: (key: string, value: boolean) => void;
}

const History: React.FC<HistoryProps> = ({
  plateDetailsHistory,
  prodScheduleList,
  productList,
  columnsHistory,
  totalElementsHistory,
  pageHistory,
  totalPagesHistory,
  sortRemovelistHistory,
  handleHistoryPageChange,
  handleFilter,
  handleSort
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className=" mx-3 pe-2" style={{ "height": "45vh" }}>
        <CustomTable
          data={plateDetailsHistory}
          columns={columnsHistory}
          isEditable={false}
          totalElements={totalElementsHistory}
          isActionVisible={false}
          isViewVisible={false}
          isSeachable={true}
          tableHead={t('Exception.history')}
          showBatchFilter={false}
          showSerielNoFilter={false}
          onFilterClick={handleFilter}
          onSortClick={handleSort}
          prodScheduleList={prodScheduleList}
          productList={productList}
          removeSortList={sortRemovelistHistory}
        />
      </div>
      <div>
        <Pagination
          page={pageHistory}
          totalPages={totalPagesHistory}
          handlePageChange={handleHistoryPageChange}
        />
      </div>
    </div>
  )
}

export default History